import React, { useEffect } from 'react'

import { useReplayStore } from '@stores'

import replayIcon from '@assets/menu/icon-replay-inactive.svg'
import shareIcon from '@assets/menu/icon-share.svg'
import { GameUIMessageType } from 'game-ui-types'
import { useTranslation } from '@amusnet/translations/react'

const Replay: React.FC = () => {
    const { t } = useTranslation()
    const isReplayFinished = useReplayStore((state) => state.isReplayFinished)
    const isLinkCopied = useReplayStore((state) => state.isLinkCopied)
    const setIsReplayFinished = useReplayStore((state) => state.setIsReplayFinished)
    const setIsLinkCopied = useReplayStore((state) => state.setIsLinkCopied)

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            const rawData = event.data
            const type = rawData.type

            switch (type) {
                case GameUIMessageType.REPLAY_ENDED: {
                    setIsReplayFinished(true)

                    break
                }
                case GameUIMessageType.REPLAY_STARTED: {
                    setIsReplayFinished(false)

                    break
                }
                default:
                    break
            }
        }

        window.addEventListener('message', handleMessage, false)

        return () => {
            window.removeEventListener('message', handleMessage, false)
        }
    }, [isReplayFinished])

    const handleWatchAgainClick = () => {
        const replayStarted = {
            type: GameUIMessageType.REPLAY_STARTED,
        }

        window.postMessage(replayStarted)
    }

    const handleCopyLinkClick = async () => {
        try {
            // await window.parent.navigator.clipboard.writeText('This is the replay link!')
            setIsLinkCopied(true)

            setTimeout(() => setIsLinkCopied(false), 3000)
        } catch (err) {
            console.error('Copy replay link failed', err)
        }
    }

    return (
        <>
            <style>{`
                @keyframes blink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.1; }
                }
            `}</style>
            <div className="fixed top-0.5 right-0.5 z-10 w-24 h-24 flex items-center justify-center rounded-full bg-black/40 font-['Roboto-Bold',_Roboto] text-6xl font-bold text-white [animation:blink_2.6s_ease-in-out_infinite] pointer-events-none">
                R
            </div>

            {isReplayFinished && (
                <div>
                    <div className="absolute inset-0 z-[12] bg-black opacity-50"></div>

                    <div className="absolute inset-0 z-[13] bg-transparent">
                        <div className="gap-4 px-5 py-10 bg-transparent min-h-[260px] rounded-xl relative h-full flex flex-col items-center justify-center">
                            <button
                                className="h-[88px] relative flex items-center justify-center gap-2.5 w-[446px] mx-auto p-4 text-white text-3xl font-bold leading-9 tracking-[0%] font-['Roboto',_sans-serif] uppercase border-[4.8px] border-transparent rounded-xl cursor-pointer bg-transparent [background-clip:padding-box]
                                    before:content-[''] before:absolute before:inset-0 before:p-[4.8px] before:-z-10 before:rounded-[inherit]
                                    before:[background:linear-gradient(135deg,#FCF1BD,#E5BC53,#F5DF96,#B8A050,#C79C36)_border-box]
                                    before:[-webkit-mask:linear-gradient(#000_0_0)_content-box,linear-gradient(#000_0_0)]
                                    before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:pointer-events-none
                                    after:content-[''] after:absolute after:inset-[4.8px] after:-z-10 after:rounded-[7px] after:bg-black/50 after:pointer-events-none
                                    hover:after:bg-[rgba(54,54,54,0.5)]"
                                onClick={handleWatchAgainClick}
                            >
                                <img src={replayIcon} />
                                {t('gameui.watchAgain')}
                            </button>
                            <div className="relative inline-block">
                                <button
                                    id="linkBtn"
                                    className="h-[88px] relative flex items-center justify-center gap-2.5 w-[446px] mx-auto p-4 text-white text-3xl font-bold leading-9 tracking-[0%] font-['Roboto',_sans-serif] uppercase border-[4.8px] border-transparent rounded-xl cursor-pointer bg-transparent [background-clip:padding-box]
                                        before:content-[''] before:absolute before:inset-0 before:p-[4.8px] before:-z-10 before:rounded-[inherit]
                                        before:[background:linear-gradient(135deg,#FCF1BD,#E5BC53,#F5DF96,#B8A050,#C79C36)_border-box]
                                        before:[-webkit-mask:linear-gradient(#000_0_0)_content-box,linear-gradient(#000_0_0)]
                                        before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:pointer-events-none
                                        after:content-[''] after:absolute after:inset-[4.8px] after:-z-10 after:rounded-[7px] after:bg-black/50 after:pointer-events-none
                                        hover:after:bg-[rgba(54,54,54,0.5)]"
                                    onClick={handleCopyLinkClick}
                                >
                                    <img src={shareIcon} />
                                    {t('gameui.createLink')}
                                </button>

                                <div
                                    id="toast"
                                    className={`absolute top-[calc(100%+12px)] left-1/2 -translate-x-1/2 bg-[#6aaf3f] text-white text-[22px] font-bold rounded-[10px] px-10 py-3.5 whitespace-nowrap z-10 ${
                                        isLinkCopied ? 'opacity-100' : 'opacity-0'
                                    }`}
                                >
                                    <div className="absolute -top-[9px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-b-[11px] border-b-[#6aaf3f]"></div>
                                    {t('gameui.linkCopied')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Replay
